module.exports = __webpack_public_path__ + "img/Vermutete_Gefahr_durch_elektrischen_Strom.4f8b0719.svg";